<div id="Questionnaire-wrapper-{{idQuestionnaire}}" (click)="closeCustomSelect($event)">
  <div class="container mt-4">
    <div class="row no-gutters">
      <div class="col-sm-offset-1 col-sm-11 px-0 px-sm-3">
        <!-- titer questionnaire  -->
        <div class="border">
          <div>
            <div class="ribbon"><h1 class="q-questionnaire-title">{{'creationQuestionnaire' | trad}}</h1></div>
            <div class="row headerQuestionnaire">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12  px-4 py-2"> <input type="text" class="form-control py-1" placeholder="{{'questionnaireTitle' | trad}}" [(ngModel)]="questionnaire.titre" /></div>
                </div>
                <div class="row">
                  <div class="col-sm-6 px-4 py-2">


                    <ckeditor [editor]="Editor"
                              [config]="ckConfigDesc"
                              [(ngModel)]="questionnaire.description"
                              skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>



                    <!--  <textarea class="form-control py-1" title="{{'questionnaireDescription' | trad}}" placeholder="{{'questionnaireDescription' | trad}}" [(ngModel)]="questionnaire.description"></textarea>-->
                  </div>
                  <div class="col-sm-6 px-4 py-2">
                    <ckeditor [editor]="Editor"
                              [config]="ckConfigMsgFin"
                              [(ngModel)]="questionnaire.messageFin"
                              skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>
                    <!-- <textarea class="form-control py-1" title="Message de fin de questionnaire" placeholder="Message de fin de questionnaire" [(ngModel)]="questionnaire.messageFin"></textarea>-->
                    <a *ngIf="questionnaire.questionnaireType == 0" style="font-size: 10px;color: var(--c-danger);font-weight: bolder;">* {{'Thisfieldcanbeusedforthevalidation'|trad}}</a>
                  </div>
                  <div class="col-sm-6 px-4 my-2"><input type="text" class="form-control py-1" title="{{'questionnaireNbPointToPass' | trad}}" placeholder="{{'questionnaireNbPointToPass' | trad}}" [(ngModel)]="questionnaire.notePassage" (ngModelChange)="getMaxNote()" /> <div class="noteMax">/{{totalPoint}}</div></div>
                  <q-tag class="col-sm-6 px-4 py-2" idPere="{{idQuestionnaire}}" relation="REL_BO_MODELQUESTIONNAIRE_BO_TAG"></q-tag>
                </div>
                <div class="row">
                  <div class="col-sm-6 px-4 py-2">
                    <div class="q-check ml-2">
                      <input type="checkbox" id="checkCertification" [(ngModel)]="questionnaire.certification.isCertification" />
                      <label class="my-0" for="checkCertification">
                        <span></span>{{'Certificationquestionnaire'|trad}}
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-6 px-4 py-2" *ngIf="questionnaire.certification.isCertification">
                    <div class="row">
                      <div class="col-5">{{'Certificationtime'|trad}}</div>
                      <select class="q-main-select col-2" #selectHour (change)="onChangeTimer()">
                        <option *ngFor="let hour of hours" value="{{hour}}">{{hour}}h</option>
                      </select>

                      <select class="q-main-select col-2" #selectMinute (change)="onChangeTimer()">
                        <option *ngFor="let minute of minutes" value="{{minute}}">{{minute}}m</option>
                      </select>

                      <select class="q-main-select col-2" #selectSecond (change)="onChangeTimer()">
                        <option *ngFor="let second of seconds" value="{{second}}">{{second}}s</option>
                      </select>
                    </div>
                  </div>
                </div>


                <div *ngIf="!questionnaire.isElearning &&  questionnaire.filterBo?.length > 0" class="row">
                  <div class="col-sm-6 px-4 py-2">
                    <div class="multiselect" (click)="showCustomSelect($event,'#checkboxesFilter')">
                      <div class="selectBox">
                        <select class="form-control">
                          <option *ngIf="nbFilter == 0">{{'Filterselection'|trad}}</option>
                          <option *ngIf="nbFilter > 0">{{nbFilter}} {{'selectedfilter'|trad}}</option>
                        </select>
                        <div id="checkboxesFilterfocus" class="overSelect"></div>
                      </div>
                      <div id="checkboxesFilter" class="customSelect filter pb-2">
                        <ng-template ngFor let-id="index" let-filter [ngForOf]="questionnaire.filterBo">
                          <div class="q-check ml-2">
                            <input type="checkbox" id="FilterBo{{id}}" (click)="onChangeFilter($event,filter)" [checked]="filter.propFilter" />
                            <label class="my-0 selectLabelAbled" for="FilterBo{{id}}">
                              <span></span>{{filter.propTitle}}
                            </label>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- Fin titer questionnaire  -->
        <div class="border mt-5 QuestTransition" [ngClass]="{'pageActived':page.IsActive}" id="page" *ngFor="let page of questionnaire.pagination; let idpage = index; let last = last">

          <div>
            <div id="Page{{idpage}}" (mousedown)="moveMenuPage(idpage)" class="col-sm-12 header q-main  p-2  text-white" #interactable><h5>Page n°{{page.numPage}}</h5></div>
            <div class="row" id="card">
              <!-- Element -->
              <ul id="{{idpage}}" class="list-group list-group-flush sortable col-sm-12 pl-3">
                <li *ngFor="let element of page.elements; index as y; let lasty = last; let odd=odd" (mousedown)="moveMenu(y,idpage,element.IsActive)" class="ui-state-default list-group-item clearfix QuestTransition" [ngClass]="{'oddElementCreate':odd,'Actived':element.IsActive}" id="Element{{element.idEl}}" #interactable>
                  <div class="cursor"></div>
                  <div class="row"> <div class="mx-auto grip"></div></div>
                  <div class="col-sm-12" [ngSwitch]="element.type">
                    <!-- Text -->
                    <ng-template [ngSwitchCase]="'text'">
                      <div class="header">
                        <input type="text" class="form-control  QuestInputBold mx-2" placeholder="{{'title' | trad}}" [(ngModel)]="element.text" />
                        <button *ngIf="element.IsActive" (click)="openMedia(element,null)" class="btn btn-circle q-hover questMediaBtn"><i class="fas fa-images"></i></button>
                      </div>
                      <!-- Media -->
                      <ng-container *ngTemplateOutlet="templateMedia;context:{pElement:element}"></ng-container>
                    </ng-template>

                    <!-- Fin Text -->
                    <!-- Question -->
                    <ng-template [ngSwitchCase]="'question'">
                      <!-- Header Question-->
                      <div class="row mt-2">
                        <ng-container [ngSwitch]="element.optionType">
                          <!--YesNo-->
                          <ng-template [ngSwitchCase]="'YesNo'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y }"></ng-container>
                            <!-- point de la question-->
                            <ng-container *ngTemplateOutlet="templatePoint;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--RADIO-->
                          <ng-template [ngSwitchCase]="'RADIOLISTENOTEQUESTION'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- point de la question-->
                            <ng-container *ngTemplateOutlet="templatePoint;context:{pElement:element}"></ng-container>
                            <!-- ajout de reponse-->
                            <ng-container *ngTemplateOutlet="templateOption;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--RADIO PONDERE-->
                          <ng-template [ngSwitchCase]="'RADIOLISTE'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- ajout de reponse-->
                            <ng-container *ngTemplateOutlet="templateOption;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--CHECKBOX LIST-->
                          <ng-template [ngSwitchCase]="'CHECKLISTENOTEQUESTION'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- point de la question-->
                            <ng-container *ngTemplateOutlet="templatePoint;context:{pElement:element}"></ng-container>
                            <!-- ajout de reponse-->
                            <ng-container *ngTemplateOutlet="templateOption;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--CHECKBOX LIST PONDERE-->
                          <ng-template [ngSwitchCase]="'CHECKLISTE'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- ajout de reponse-->
                            <ng-container *ngTemplateOutlet="templateOption;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--TEXTAREA-->
                          <ng-template [ngSwitchCase]="'TEXTBOX'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- point de la question-->
                            <ng-container *ngTemplateOutlet="templatePoint;context:{pElement:element}"></ng-container>

                          </ng-template>

                          <!--AVIS-->
                          <ng-template [ngSwitchCase]="'AVIS'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- point de la question-->
                            <ng-container *ngTemplateOutlet="templatePoint;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--SATISFACTION-->
                          <ng-template [ngSwitchCase]="'SATISFACTION'">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                          </ng-template>

                          <!--GAPFILL-->
                          <ng-template [ngSwitchCase]="'GAPFILL'">
                            <!-- titre question-->
                            <ng-container [ngIf]="element.IsActive" *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- ajout de reponse-->
                            <ng-container *ngTemplateOutlet="templateOption;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--DOMINO-->
                          <ng-template [ngSwitchCase]="'DOMINO'">
                            <!-- titre question-->
                            <ng-container [ngIf]="element.IsActive" *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- ajout de reponse-->
                            <ng-container *ngTemplateOutlet="templateOption;context:{pElement:element}"></ng-container>
                          </ng-template>

                          <!--MATCHING-->
                          <ng-template [ngSwitchCase]="'MATCHING'">
                            <!-- titre question-->
                            <ng-container [ngIf]="element.IsActive" *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                            <!-- point de la question-->
                            <ng-container *ngTemplateOutlet="templatePoint;context:{pElement:element}"></ng-container>
                          </ng-template>


                          <!--MATCHINGNOTEREPONSE-->
                          <ng-template [ngSwitchCase]="'MATCHINGNOTEREPONSE'">
                            <!-- titre question-->
                            <ng-container [ngIf]="element.IsActive" *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                          </ng-template>


                          <!--Default-->
                          <ng-template [ngSwitchCase]="-1">
                            <!-- titre question-->
                            <ng-container *ngTemplateOutlet="templateTitle;context:{pElement:element}"></ng-container>
                            <!-- choix type de reponse -->
                            <ng-container *ngTemplateOutlet="templateSelectType;context:{pElement:element,pIdPage:idpage,pIdQuest:y}"></ng-container>
                          </ng-template>
                        </ng-container>

                      </div>

                      <!-- Media -->
                      <ng-container *ngTemplateOutlet="templateMedia;context:{pElement:element}"></ng-container>

                      <!-- Fin Header Question-->
                      <hr *ngIf="(element.options.length > 0) && element.IsActive" class="hrElement my-0">
                      <!-- Reponse -->


                      <ng-container [ngSwitch]="element.optionType">
                        <!--YesNo-->
                        <ng-template [ngSwitchCase]="'YesNo'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else YesNoNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div class="col-12 col-md-9  px-1 py-2">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                  </div>
                                  <div class="col-3 col-md-2  px-1 py-2">
                                    <input id="required{{page.numPage}}{{y}}{{w}}" type="checkbox" [(ngModel)]="option.isCorrectAnswer" (click)="onChangeCorrectAnswer(element,option)" class="cbx hidden" />
                                    <label for="required{{page.numPage}}{{y}}{{w}}" class="lbl mt-2"></label>
                                  </div>
                                  <!-- <button class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>-->
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                          <!--NOT ACTIVE-->
                          <ng-template #YesNoNotActive>
                            <ul class="list-group list-group-flush" id="choix">
                              <div class="row">
                                <div class="col-6">
                                  <div class="float-right">
                                    <input disabled class="YesNo ouiBtn  float-sm-right" name="OuiNon" type="radio" id="oui">
                                    <label for="oui">{{element.options[0].text}}</label>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div>
                                    <input disabled class="YesNo nonBtn" name="OuiNon" type="radio" id="non">
                                    <label for="non">{{element.options[1].text}}</label>
                                  </div>
                                </div>
                              </div>
                            </ul>
                          </ng-template>
                        </ng-template>

                        <!--RADIO-->
                        <ng-template [ngSwitchCase]="'RADIOLISTENOTEQUESTION'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else RadioNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div [ngClass]="element.IsActive? 'col-12 col-md-9  px-1 py-2': 'col-12 col-md-12  px-1 py-2'" class="QuestTransition">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                    <button (click)="openMedia(element,option)" class="btn btn-circle q-hover questMediaBtn"><i class="fas fa-images"></i></button>
                                  </div>
                                  <div *ngIf="element.IsActive" class="col-3 col-md-2  px-1 py-2">
                                    <input id="required{{page.numPage}}{{y}}{{w}}" type="checkbox" [(ngModel)]="option.isCorrectAnswer" (click)="onChangeCorrectAnswer(element,option)" class="cbx hidden" />
                                    <label for="required{{page.numPage}}{{y}}{{w}}" class="lbl mt-2"></label>
                                  </div>
                                  <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                                <ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container>
                              </li>
                            </ul>
                          </ng-container>

                          <!--NOT ACTIVE-->
                          <ng-template #RadioNotActive>
                            <ng-container *ngIf="!element.mediaOption; else RadioMedia">
                              <ul class="list-group list-group-flush" id="choix">
                                <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="row item">
                                    <div class="my-1 inputGroup inputRound w-100">
                                      <input disabled type="radio" />
                                      <label>{{option.text}}</label>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </ng-container>
                            <ng-template #RadioMedia>
                              <div class="row mx-0">
                                <div class="col-md-6 px-1" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="my-1 inputGroup inputRound questMediaImg">
                                    <input type="checkbox" />
                                    <label>
                                      <div class="inputContentImg">
                                        <div><ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container></div>
                                        <a class="row justify-content-center">{{option.text}}</a>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </ng-template>
                        </ng-template>

                        <!--RADIO PONDERE-->
                        <ng-template [ngSwitchCase]="'RADIOLISTE'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else RadioPondereNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div class="col-12 col-md-9  px-1 py-2">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                    <button (click)="openMedia(element,option)" class="btn btn-circle q-hover questMediaBtn"><i class="fas fa-images"></i></button>
                                  </div>
                                  <div class="col-3 col-md-2  px-1 py-2">
                                    <div>
                                      <input class="form-control py-1" type="text" placeholder="{{'point' | trad}}" [(ngModel)]="option.point" (ngModelChange)="getMaxNote();elementMaxNote(element)" />
                                    </div>
                                  </div>
                                  <button class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                                <ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container>
                              </li>
                            </ul>
                          </ng-container>
                          <!--NOT ACTIVE-->
                          <ng-template #RadioPondereNotActive>
                            <ng-container *ngIf="!element.mediaOption; else RadioPondereMedia">
                              <ul class="list-group list-group-flush" id="choix">
                                <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="row item">
                                    <div class="mx-1 mx-sm-4 my-1 inputGroup inputRound w-100">
                                      <input disabled type="radio" />
                                      <label>{{option.text}}</label>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </ng-container>
                            <ng-template #RadioPondereMedia>
                              <div class="row mx-0">
                                <div class="col-md-6 px-1" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="my-1 inputGroup inputRound questMediaImg">
                                    <input type="checkbox" />
                                    <label>
                                      <div class="inputContentImg">
                                        <div><ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container></div>
                                        <a class="row justify-content-center">{{option.text}}</a>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </ng-template>
                        </ng-template>

                        <!--CHECKBOX LIST-->
                        <ng-template [ngSwitchCase]="'CHECKLISTENOTEQUESTION'">
                          <ng-container *ngIf="element.IsActive; else CheckNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div [ngClass]="element.IsActive? 'col-12 col-md-9  px-1 py-2': 'col-12 col-md-12  px-1 py-2'" class="QuestTransition">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                    <button (click)="openMedia(element,option)" class="btn btn-circle q-hover questMediaBtn"><i class="fas fa-images"></i></button>
                                  </div>
                                  <div *ngIf="element.IsActive" class="col-3 col-md-2  px-1 py-2">
                                    <input id="required{{page.numPage}}{{y}}{{w}}" type="checkbox" [(ngModel)]="option.isCorrectAnswer" (click)="onChangeCorrectAnswer(element,option)" class="cbx hidden" />
                                    <label for="required{{page.numPage}}{{y}}{{w}}" class="lbl mt-2"></label>
                                  </div>
                                  <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                                <ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container>
                              </li>
                            </ul>
                          </ng-container>
                          <!--NOT ACTIVE-->
                          <ng-template #CheckNotActive>
                            <ng-container *ngIf="!element.mediaOption; else CheckMedia">
                              <ul class="list-group list-group-flush" id="choix">
                                <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="row item">
                                    <div class="mx-1 mx-sm-4 my-1 inputGroup w-100">
                                      <input disabled type="checkbox" />
                                      <label>{{option.text}}</label>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </ng-container>
                            <ng-template #CheckMedia>
                              <div class="row mx-0">
                                <div class="col-md-6 px-1" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="my-1 inputGroup questMediaImg">
                                    <input type="checkbox" />
                                    <label>
                                      <div class="inputContentImg">
                                        <div><ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container></div>
                                        <a class="row justify-content-center">{{option.text}}</a>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </ng-template>


                        </ng-template>

                        <!--CHECKBOX LIST PONDERE-->
                        <ng-template [ngSwitchCase]="'CHECKLISTE'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else CheckPondereNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div [ngClass]="element.IsActive? 'col-12 col-md-9  px-1 py-2': 'col-12 col-md-12  px-1 py-2'" class="QuestTransition">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                    <button (click)="openMedia(element,option)" class="btn btn-circle q-hover questMediaBtn"><i class="fas fa-images"></i></button>
                                  </div>
                                  <div *ngIf="element.IsActive" class="col-3 col-md-2  px-1 py-2">
                                    <input class="form-control py-1" type="text" placeholder="{{'point' | trad}}" [(ngModel)]="option.point" (ngModelChange)="getMaxNote();elementMaxNote(element)" />
                                  </div>
                                  <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                                <ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container>
                              </li>
                            </ul>
                          </ng-container>
                          <!--NOT ACTIVE-->
                          <ng-template #CheckPondereNotActive>
                            <ng-container *ngIf="!element.mediaOption; else CheckPondereMedia">
                              <ul class="list-group list-group-flush" id="choix">
                                <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="row item">
                                    <div class="mx-1 mx-sm-4 my-1 inputGroup w-100">
                                      <input disabled type="checkbox" />
                                      <label>{{option.text}}</label>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </ng-container>
                            <ng-template #CheckPondereMedia>
                              <div class="row mx-0">
                                <div class="col-md-6 px-1" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                  <div class="my-1 inputGroup questMediaImg">
                                    <input type="checkbox" />
                                    <label>
                                      <div class="inputContentImg">
                                        <div><ng-container *ngTemplateOutlet="templateMediaOption;context:{pOption:option, pElement:element}"></ng-container></div>
                                        <a class="row justify-content-center">{{option.text}}</a>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </ng-template>
                        </ng-template>

                        <!--TEXTAREA-->
                        <ng-template [ngSwitchCase]="'TEXTBOX'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else TextBoxNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div [ngClass]="element.IsActive? 'col-12 col-md-9  px-1 py-2': 'col-12 col-md-12  px-1 py-2'" class="QuestTransition">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                  </div>
                                  <div class="col-3 col-md-2  px-1 py-2">
                                  </div>
                                  <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                              </li>
                            </ul>
                          </ng-container>
                          <!--NOT ACTIVE-->
                          <ng-template #TextBoxNotActive>
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <label>
                                  {{option.text}}
                                </label>
                                <div style="float:left;width:100%;">
                                  <textarea disabled class="q-textarea" rows="5"></textarea>
                                </div>
                              </li>
                            </ul>
                          </ng-template>

                        </ng-template>

                        <!--AVIS-->
                        <ng-template [ngSwitchCase]="'AVIS'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else AvisNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <div class="row item">
                                  <div [ngClass]="element.IsActive? 'col-12 col-md-9  px-1 py-2': 'col-12 col-md-12  px-1 py-2'" class="QuestTransition">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" />
                                  </div>
                                  <div class="col-3 col-md-2  px-1 py-2">
                                  </div>
                                  <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,w)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                              </li>
                            </ul>
                          </ng-container>


                          <!--NOT ACTIVE-->
                          <ng-template #AvisNotActive>
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let w = index">
                                <label>
                                  {{option.text}}
                                </label>
                                <div style="float:left;width:100%;">
                                  <textarea disabled class="q-textarea" rows="5"></textarea>
                                </div>
                              </li>
                            </ul>
                          </ng-template>
                        </ng-template>

                        <!--SATISFACTION-->
                        <ng-template [ngSwitchCase]="'SATISFACTION'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else SatisfactionNotActive">
                            <ul class="list-group list-group-flush" id="choix"></ul>
                          </ng-container>
                          <!--NOT ACTIVE-->
                          <ng-template #SatisfactionNotActive>
                            <ul class="list-group list-group-flush" id="choix">
                              <label>
                                {{element.options[0].text}}
                              </label>
                              <div class="row">
                                <div class="star-rating pl-5">
                                  <div class="star-rating__wrap">
                                    <input disabled class="star-rating__input" id="star-rating-5" type="radio" name="rating" value="5">
                                    <label class="star-rating__ico far fa-star fa-2x" for="star-rating-5" title="5"></label>
                                    <input disabled class="star-rating__input" id="star-rating-4" type="radio" name="rating" value="4">
                                    <label class="star-rating__ico far fa-star fa-2x" for="star-rating-4" title="4"></label>
                                    <input disabled class="star-rating__input" id="star-rating-3" type="radio" name="rating" value="3">
                                    <label class="star-rating__ico far fa-star fa-2x" for="star-rating-3" title="3"></label>
                                    <input disabled class="star-rating__input" id="star-rating-2" type="radio" name="rating" value="2">
                                    <label class="star-rating__ico far fa-star fa-2x" for="star-rating-2" title="2"></label>
                                    <input disabled class="star-rating__input" id="star-rating-1" type="radio" name="rating" value="1">
                                    <label class="star-rating__ico far fa-star fa-2x" for="star-rating-1" title="1"></label>
                                  </div>
                                </div>
                              </div>
                            </ul>
                          </ng-template>
                        </ng-template>

                        <!--GAPFILL-->
                        <ng-template [ngSwitchCase]="'GAPFILL'">
                          <!--ACTIVE-->
                          <ng-container *ngIf="element.IsActive; else GapFillNotActive">
                            <ul class="list-group list-group-flush" id="choix">
                              <li class="list-group-item clearfix borderless my-0 py-0" [ngClass]="{'oddElementCreate':odd}" *ngFor=" let option of element.options ; let optionIndex = index">
                                <div class="row item">
                                  <div class="QuestTransition col-12 col-md-9  px-1 py-2">
                                    <input class="form-control py-1" type="text" placeholder="{{'intituleReponse' | trad}}" [(ngModel)]="option.text" (ngModelChange)="generateGapOption(element,optionIndex)" />
                                  </div>
                                  <div class="col-3 col-md-2  px-1 py-2">
                                    <input class="form-control py-1" type="text" placeholder="{{'point' | trad}}" [(ngModel)]="option.point" (ngModelChange)="getMaxNote();elementMaxNote(element)" />
                                  </div>
                                  <button class="btn  btn-danger btn-circle mt-2" (click)="deleteOption(element.options,optionIndex)" title="{{'deleteOption' | trad}}"><i class="fa fa-trash"></i></button>
                                </div>
                                <div class="row item">
                                  <div class="QuestTransition col-12 col-md-12  px-1 py-2">
                                    <a *ngFor="let word of option.text.split(' '),let i = index" (click)="selectWord(i,element,optionIndex)" [ngClass]="selectedWord(word)" class="gapFillWord"> {{word}}</a>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </ng-container>

                          <!--NOT ACTIVE-->
                          <ng-template #GapFillNotActive>
                            <div *ngFor="let option of element.options; let w = index ; let first = first" [ngClass]="{'oddElementCreate':odd}" class="element.mediaOption?'col-md-6 px-1':'col-md-12 px-1'">

                              <div class="row pl-5 pt-2 pb-2">
                                <ng-template ngFor let-i="index" let-word [ngForOf]="option.text.split(' ')">

                                  <div *ngIf="word.includes('[') && word.includes(']')">
                                    <input class="gapWord" type="text" [(ngModel)]="option.gapsFill[i].answer" />
                                  </div>
                                  <a class="gapWord" *ngIf="!(word.includes('[') && word.includes(']'))">{{word}}</a>
                                </ng-template>
                              </div>
                            </div>
                          </ng-template>
                        </ng-template>

                        <!--DOMINO-->
                        <ng-template [ngSwitchCase]="'DOMINO'">
                          <Domino-Question [Mode]="element.IsActive ? ModeQuestion.create : ModeQuestion.cDiplay" [QuestElement]="element" [(DeletedElement)]="deletedElement" [Odd]="odd" (GetMaxNote)="getMaxNote()"></Domino-Question>
                        </ng-template>

                        <!--MATCHING-->
                        <ng-template [ngSwitchCase]="'MATCHING'">
                          <Matching-Question [Mode]="element.IsActive ? ModeQuestion.create : ModeQuestion.cDiplay" [QuestElement]="element" [(DeletedElement)]="deletedElement" [NoteQuestion]="true"></Matching-Question>
                        </ng-template>


                        <!--MATCHING POINT PAR REPONSE-->
                        <ng-template [ngSwitchCase]="'MATCHINGNOTEREPONSE'">
                          <Matching-Question [Mode]="element.IsActive ? ModeQuestion.create : ModeQuestion.cDiplay" [QuestElement]="element" [(DeletedElement)]="deletedElement" [NoteQuestion]="false" (GetMaxNote)="getMaxNote()"></Matching-Question>
                        </ng-template>

                      </ng-container>

                      <!-- Fin Reponse -->
                      <hr *ngIf="element.IsActive" class="hrElement my-0">
                      <!-- Footer -->
                      <div *ngIf="element.IsActive" class="pt-3">


                        <div class="row" [ngClass]="element.commentaire || element.hint || element.plusOption? 'elementPlusOptionExpended' : 'elementPlusOptionCollapsed'">
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-12">
                                <div class="row">
                                  <div class=" col-2">
                                    <label>{{'indice' | trad}}</label>
                                  </div>
                                  <div class="col-6 col-md-3  pt-1">
                                    <input id="hint{{page.numPage}}{{y}}" type="checkbox" [(ngModel)]="element.hint" class="cbx hidden" />
                                    <label for="hint{{page.numPage}}{{y}}" class="lbl"></label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <ng-container *ngIf="element.optionType!=='SATISFACTION'">
                                  <ckeditor *ngIf="element.hint" [editor]="Editor" [config]="ckConfigIndice" [(ngModel)]="element.hintCorrect" skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-12">
                                <div class="row">
                                  <div class="col-3">
                                    <label>{{'comment'|trad}}</label>
                                  </div>
                                  <div class="col-6 col-md-3  pt-1">
                                    <input id="com{{page.numPage}}{{y}}" type="checkbox" [(ngModel)]="element.commentaire" class="cbx hidden" />
                                    <label for="com{{page.numPage}}{{y}}" class="lbl"></label>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <ckeditor *ngIf="element.commentaire" [editor]="Editor" [config]="ckConfigCommentaire" [(ngModel)]="element.commentaireTxt" skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>
                              </div>


                            </div>
                          </div>
                        </div>

                        <hr *ngIf="element.commentaire  || element.hint || element.plusOption" class="hrElement">

                        <div class="row">
                          <div class="offset-md-9 col-11 col-md-2">
                            <div class="row">
                              <div class="col-6 col-md-8">
                                <label>{{'obligatoire' | trad}}</label>
                              </div>
                              <div class="col-6 col-md-2 pt-1 ">
                                <input id="required{{page.numPage}}{{y}}" type="checkbox" [(ngModel)]="element.required" class="cbx hidden" />
                                <label for="required{{page.numPage}}{{y}}" class="lbl"></label>
                              </div>
                            </div>
                          </div>
                          <div class="col-1 pl-5" title="plus d'options">
                            <i *ngIf="!element.plusOption" (click)="element.plusOption = element.commentaire  || element.hint ?false: true" class="fas fa-chevron-down cursorPointer"></i>
                            <i *ngIf="element.plusOption" (click)="element.plusOption = false" class="fas fa-chevron-up cursorPointer"></i>
                          </div>
                        </div>



                      </div>
                      <!-- Fin Footer-->
                    </ng-template>
                    <!-- Fin Question -->
                  </div>
                </li>
              </ul>
              <!-- Fin Element -->
            </div>
          </div>
        </div>
      </div>
      <!-- Side menu -->
      <div class="col-sm-1">
        <div *ngIf="screenWidht > 767" class="card-menu" id="menu" #menu>
          <button class="btn  btn-circle pulsebtn" (click)="addElement('question')" title="{{'addQuestion' | trad}}"><i class="fa fa-plus"></i></button>
          <button class="btn  greenBG btn-circle" (click)="updateQuestionnaire()" title="{{'save' | trad}}"><i class="fa fa-save"></i></button>
          <button class="btn  btn-circle" (click)="addElement('text')" title="{{'addTitle' | trad}}" *ngIf="!questionnaire.certification.isCertification"><i class="fa fa-align-left"></i></button>
          <button class="btn  btn-circle" (click)="addPage()" title="{{'addPage' | trad}}"><i class="fa fa-file"></i></button>


          <button class="btn  btn-circle" data-toggle="modal" data-target="#ModalGroup" title="Groupe de questions"><i class="fas fa-layer-group"></i></button>
          <button class="btn  btn-danger btn-circle" (click)="openModalConfirmDelete(ModalDeleteValidation)" title="{{'deleteElement' | trad}}" *ngIf="showDelete"><i class="fa fa-trash"></i></button>
        </div>
        <div *ngIf="screenWidht <= 767" class="card-menu-mobile">
          <button class="btn  btn-circle btnplus pulsebtn" (click)="addElement('question')"><i class="fa fa-plus"></i></button>
          <button class="btn  btn-success btn-circle" (click)="updateQuestionnaire()"><i class="fa fa-save"></i></button>
          <button class="btn  btn-circle" (click)="addElement('text')" *ngIf="!questionnaire.certification.isCertification"><i class="fa fa-align-left"></i></button>
          <button class="btn  btn-circle" (click)="addPage()"><i class="fa fa-file"></i></button>
          <button class="btn  btn-danger btn-circle" (click)="openModalConfirmDelete(ModalDeleteValidation)" *ngIf="showDelete"><i class="fa fa-trash"></i></button>

        </div>
      </div>
    </div>
  </div>



  <!--<button class="btn btn-circle btn-lg btn-bottom color_button" (click)="goBack()"> <i class="fa fa-arrow-left 2x"></i></button>-->
  <!-- Modal -->
  <div class="modal fade" id="ModaleQuestionnaire" tabindex="-1" role="dialog" aria-labelledby="ModaleQuestionnaire" aria-hidden="true" #DeteleModal>
    <div class="modal-dialog modal-dialog-centered modalQuest" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle"></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <q-questionnaire *ngIf="answerModel.modeQuestionnaire =='visualisation'" [inputAnswerModel]="answerModel"></q-questionnaire>
        </div>
      </div>
    </div>
  </div>


  <!-- Modal GROUPE QUESTION -->
  <div class="modal fade" id="ModalGroup" tabindex="-1" role="dialog" aria-labelledby="ModalGroup" aria-hidden="true" #ModalGroup (click)="closeCustomSelect($event)">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content ">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            {{'Managementofquestiongroups'|trad}}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" #CloseConvertion>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <button class="btn  btn-circle pulsebtn mb-2" title="{{'Createagroup' | trad}}" (click)="addGroup()"><i class="fa fa-plus"></i></button> {{'Createagroup'|trad}}


          <div class="row pt-2 px-4">

            <div class="col-12 mb-2" *ngFor="let group of questionnaire.group,let idGroup = index">

              <div class="row pb-1 align-items-center">
                <input class="col-12 col-md-3 form-control" type="text" [(ngModel)]="group.groupName" placeholder="Nom du groupe" (ngModelChange)="changeGroup(idGroup)" />

                <div class="multiselect col-12 col-md-5" (click)="showCustomSelect($event,'#checkboxes'+idGroup)">
                  <div class="selectBox">
                    <select class="form-control">

                      <option *ngIf="group.groupElements.length == 0">{{'Selectionofquestion'|trad}}</option>
                      <option *ngIf="group.groupElements.length > 0">{{group.groupElements.length}} {{'selectedquestion'|trad}}</option>

                    </select>
                    <div id="checkboxes{{idGroup}}focus" class="overSelect"></div>
                  </div>
                  <div id="checkboxes{{idGroup}}" class="customSelect group pb-2">

                    <ng-template ngFor let-idpage="index" let-page [ngForOf]="questionnaire.pagination">
                      <h6 class="q-c-main pt-1 my-0 ml-3"><small>Page {{idpage+1}}</small></h6>
                      <ng-template ngFor let-idelem="index" let-element [ngForOf]="page.elements">
                        <ng-container *ngIf="element.type === 'question'">


                          <div class="q-check px-2">
                            <input type="checkbox" id="{{idGroup}}{{idpage}}{{idelem}}" (click)="onChangeQuestionGroup($event,idpage,idelem,idGroup,group.groupName)" [disabled]="element.groupName != group.groupName && element.groupName != '' && element.groupName" [checked]="element.groupName == group.groupName" />
                            <label class="my-0" for="{{idGroup}}{{idpage}}{{idelem}}" [ngClass]="(element.groupName != group.groupName && element.groupName != '' && element.groupName)? 'selectLabelDisabled' : 'selectLabelAbled'">
                              <span></span>{{element.text}}
                            </label>
                          </div>

                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </div>
                </div>


                <div class="col-2 row" *ngIf="group.groupElements.length > 0">
                  <input class="form-control col-8" type="text" [(ngModel)]="group.groupPoint" (ngModelChange)="changeGroup(idGroup)" placeholder="Note" />
                  <div class="col-4 pt-2">/{{group.randomEl > 0 ? group.groupPointMaxRng : group.groupPointMax}}</div>
                </div>

                <i class="fa fa-trash col-1 q-c-danger q-pointer" title="Supprimer le groupe" (click)="deleteGroup(idGroup)"></i>
                <i class="fas fa-random col-1  q-pointer" title="Rendre aléatoire l'ordre des questions du groupe" [ngClass]="group.isRandom? 'randomActive':''" (click)="toggleRandomGroup(idGroup)"></i>
              </div>

              <div class="row align-items-center" *ngIf="group.isRandom">
                <div class="col-6 col-md-5 ">{{'Numberofrandomquestions'|trad}} </div>  <input class="col-6 col-md-2 form-control " type="number" min="0" max="{{group.groupElements.length}}" [(ngModel)]="group.randomEl" (ngModelChange)="changeGroup(idGroup)" placeholder="Nombre de question aléatoire" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- #region Template -->
  <ng-template #templateTitle let-element="pElement">
    <div [ngStyle]="getGroupStyle(element)" class="groupPill">{{element.groupName}}</div>
    <!--ACTIVE-->
    <ng-container *ngIf="element.IsActive; else titleNotActive">
      <div Class="col-md-7 px-1 py-2">
        <input class="form-control py-1  QuestInputBold" type="text" placeholder="{{'intituleQuestion' | trad}}" [(ngModel)]="element.text" />
        <button (click)="openMedia(element,null)" class="btn btn-circle q-hover questMediaBtn"><i class="fas fa-images"></i></button>
      </div>
    </ng-container>
    <!--NOT ACTIVE-->
    <ng-template #titleNotActive>
      <h5 class="q-question">{{element.text}}</h5>
    </ng-template>
  </ng-template>

  <ng-template #templateSelectType let-element="pElement" let-idPage="pIdPage" let-idQuest="pIdQuest">
    <div *ngIf="element.IsActive" class="col-8 col-md-3 px-1 py-2">

      <div class="multiselect" (click)="showCustomSelect($event,'#SelectQuest'+idPage+idQuest)">
        <div class="selectBox">
          <select class="form-control" [(ngModel)]="element.optionType">
            <option value="-1" disabled selected>{{'typeQuestion' | trad}}</option>
            <option value="CHECKLISTENOTEQUESTION">{{'Checkbox'|trad}}</option>
            <option value="RADIOLISTENOTEQUESTION">{{'choixUnique'|trad}}</option>
            <option value="CHECKLISTE">{{'Checkbox'|trad}}</option>
            <option value="RADIOLISTE">{{'choixUnique'|trad}}</option>
            <option value="YesNo">{{'YesNo'|trad}}</option>
            <option value="MATCHING">{{'pointstoconnect'|trad}}</option>
            <option value="MATCHINGNOTEREPONSE">{{'pointstoconnect'|trad}}</option>
            <option value="GAPFILL">{{'Fillintheblanktext'|trad}}</option>
            <option value="DOMINO">Domino</option>
            <option *ngIf="!questionnaire.isElearning" value="TEXTBOX">{{'redactionnel'|trad}}</option>
            <option *ngIf="!questionnaire.isElearning" value="SATISFACTION">{{'satisfaction'|trad}}</option>
            <option *ngIf="!questionnaire.isElearning" value="AVIS"> {{'avis' | trad}}</option>
          </select>
          <div id="SelectQuest{{idPage}}{{idQuest}}focus" class="overSelect"></div>
        </div>
        <div id="SelectQuest{{idPage}}{{idQuest}}" class="customSelect pb-2">
          <h6 class="q-c-main pt-1 my-0 ml-3"><small>{{'Pointsperanswer'|trad}}</small></h6>
          <div (click)="onChangeOption('CHECKLISTE',element)" [ngClass]="{'active':element.optionType == 'CHECKLISTE'}" class="q-questionType"><i class="far fa-check-square"></i><div>{{'Checkbox'|trad}}</div></div>
          <div (click)="onChangeOption('RADIOLISTE',element)" [ngClass]="{'active':element.optionType == 'RADIOLISTE'}" class="q-questionType"><i class="far fa-check-circle"></i><div>{{'choixUnique'|trad}}</div></div>
          <div (click)="onChangeOption('GAPFILL',element)" [ngClass]="{'active':element.optionType == 'GAPFILL'}" class="q-questionType"><i class="questIcon-textatrou"></i><div>{{'Fillintheblanktext'|trad}}</div></div>
          <div (click)="onChangeOption('MATCHINGNOTEREPONSE',element)" [ngClass]="{'active':element.optionType == 'MATCHINGNOTEREPONSE'}" class="q-questionType"><i class="questIcon-pointsarelier"></i> <div>{{'pointstoconnect'|trad}}</div></div>
          <div (click)="onChangeOption('DOMINO',element)" [ngClass]="{'active':element.optionType == 'DOMINO'}" class="q-questionType"><i class="questIcon-textatrou"></i><div>Domino</div></div>

          <h6 class="q-c-main pt-2 my-0 ml-3"><small>{{'pointsperquestion'|trad}}</small></h6>
          <div (click)="onChangeOption('CHECKLISTENOTEQUESTION',element)" [ngClass]="{'active':element.optionType == 'CHECKLISTENOTEQUESTION'}" class="q-questionType"><i class="far fa-check-square"></i><div>{{'Checkbox'|trad}}</div></div>
          <div (click)="onChangeOption('RADIOLISTENOTEQUESTION',element)" [ngClass]="{'active':element.optionType == 'RADIOLISTENOTEQUESTION'}" class="q-questionType"><i class="far fa-check-circle"></i><div>{{'choixUnique'|trad}}</div></div>
          <div (click)="onChangeOption('YesNo',element)" [ngClass]="{'active':element.optionType == 'YesNo'}" class="q-questionType"><i class="questIcon-ouinon"></i><div>{{'YesNo'|trad}}</div></div>
          <div (click)="onChangeOption('MATCHING',element)" [ngClass]="{'active':element.optionType == 'MATCHING'}" class="q-questionType"><i class="questIcon-pointsarelier"></i> <div>{{'pointstoconnect'|trad}}</div></div>
          <div (click)="onChangeOption('TEXTBOX',element)" [ngClass]="{'active':element.optionType == 'TEXTBOX'}" class="q-questionType" *ngIf="!questionnaire.isElearning"><i class="fas fa-align-left"></i><div>{{'redactionnel'|trad}}</div></div>
          <div (click)="onChangeOption('SATISFACTION',element)" [ngClass]="{'active':element.optionType == 'SATISFACTION'}" class="q-questionType" *ngIf="!questionnaire.isElearning"><i class="far fa-star"></i><div>{{'satisfaction'|trad}}</div></div>

        </div>
      </div>











    </div>
  </ng-template>

  <ng-template #templatePoint let-element="pElement">

    <div *ngIf="element.IsActive" class="col-3 col-md-1 px-1 py-2">
      <input class="form-control py-1 px-1 QuestInput" type="text" placeholder="point" title="nombre de points" [(ngModel)]="element.maxPoint" (ngModelChange)="getMaxNote();updateGroupNote()" />
    </div>
  </ng-template>

  <ng-template #templateOption let-element="pElement">
    <div class="col-1 px-1 py-2" *ngIf="element.optionType && element.IsActive">
      <button class="btn  btn-circle q-hover" (click)="addOption(element.options)" title="{{'addOption' | trad}}"><i class="fa fa-plus"></i></button>
    </div>
  </ng-template>

  <!-- #region Element Media -->
  <ng-template #templateMedia let-element="pElement">
    <ng-container [ngSwitch]="element.mediaType">
      <div class="row justify-content-center no-gutters">
        <ng-template [ngSwitchCase]="'VIDEO'">
          <video class="questMedia" src="{{element.mediaPath}}" controls></video>
          <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2 removeMediaBtn" (click)="removeMedia(element,null)"><i class="fa fa-trash"></i></button>
        </ng-template>
        <ng-template [ngSwitchCase]="'IMG'">
          <img class="questMedia" src="{{element.mediaPath}}" />
          <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2 removeMediaBtn" (click)="removeMedia(element,null)"><i class="fa fa-trash"></i></button>
        </ng-template>
        <ng-template [ngSwitchCase]="'AUDIO'">
          <audio class="questMedia" src="{{element.mediaPath}}" controls></audio>
          <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2 removeMediaBtn" (click)="removeMedia(element,null)"><i class="fa fa-trash"></i></button>
        </ng-template>
      </div>
    </ng-container>
  </ng-template>
  <!-- #endregion -->
  <!-- #region Option Media -->
  <ng-template #templateMediaOption let-option="pOption" let-element="pElement">
    <ng-container [ngSwitch]="option.mediaType">
      <div class="row justify-content-center no-gutters">
        <ng-template [ngSwitchCase]="'VIDEO'">
          <video class="questMedia" src="{{option.mediaPath}}" controls></video>
          <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2 removeMediaBtn" (click)="removeMedia(element,option)"><i class="fa fa-trash"></i></button>
        </ng-template>
        <ng-template [ngSwitchCase]="'IMG'">
          <img class="questMedia" src="{{option.mediaPath}}" />
          <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2 removeMediaBtn" (click)="removeMedia(element,option)"><i class="fa fa-trash"></i></button>
        </ng-template>
        <ng-template [ngSwitchCase]="'AUDIO'">
          <audio class="questMedia" src="{{option.mediaPath}}" controls></audio>
          <button *ngIf="element.IsActive" class="btn  btn-danger btn-circle mt-2 removeMediaBtn" (click)="removeMedia(element,option)"><i class="fa fa-trash"></i></button>
        </ng-template>
      </div>
    </ng-container>
  </ng-template>
  <!-- #endregion -->
  <!-- #endregion -->



  <button class="hidden" data-toggle="modal" data-target="#ModaleMedia" #openModalMedia></button>
  <div class="modal fade" id="ModaleMedia" tabindex="-1" role="dialog" aria-labelledby="ModaleMedia" aria-hidden="true" #ModaleMedia>
    <div class="modal-dialog modal-dialog-centered modalQuest" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle"></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" #cloneModalMedia>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <q-media (media)="selectMedia($event)" [restrictedTo]="filterMedia"></q-media>
        </div>
      </div>
    </div>
  </div>
</div>

<!--  MODAL de validation de la suppression des images -->
<ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
  <div class="modal-content">
      <button type="button" class="close text-right mr-1" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    <h5 class="text-center">{{txtConfirmDelete}} ?</h5>
    <div class="text-center">
      <button class="btn q-btn q-danger m-2" type="button" (click)="deleteElement();modal.dismiss()"
              title="Supprimer l'élément">
        <i class="fas fa-trash mr-2"></i> Supprimer
      </button>
      <button class="btn q-btn q-dark-grey m-2" type="button" (click)="modal.dismiss()"
              title="Retour">
        <i class="fas fa-undo mr-2"></i> Annuler
      </button>
    </div>
  </div>
</ng-template>
